import React from 'react';
import PropTypes from 'prop-types';
import HfReactHelper from 'js/sign-components/common/hf-react-helper';
import createReactClass from 'create-react-class';
import { FormattedMessage } from 'react-intl';
import { getBrandName, siteCodes } from 'js/sign-components/common/brand';
import classNames from 'classnames';
import Logo from 'signer-app/parts/logo-v2';

import facebookImageSrc from './fb@2x.png';
import styles from './footer.module.css';
import './index.scss';
import linkedinImageSrc from './linkedin@2x.png';
import LegacyFooterHoverMenu from './legacy-footer-hover-menu';
import twitterImageSrc from './twitter@2x.png';

const MenuLink = (props) => (
  <a
    className={classNames(styles.menuItem, 'm-app-footer--menu-item')}
    display="block"
    target="_blank"
    {...props}
  />
);

const AppFooter = createReactClass({
  propTypes: {
    siteCode: PropTypes.string.isRequired, // S, F, or W
    termsURL: PropTypes.string.isRequired,
    privacyURL: PropTypes.string.isRequired,
    responsive: PropTypes.bool,
  },

  SOCIAL_NAMES: ['linkedin', 'fb', 'twitter'],
  SOCIAL_URLS: {
    // eslint-disable-next-line no-restricted-syntax
    twitter: 'https://x.com/dropbox',
    // eslint-disable-next-line no-restricted-syntax
    fb: 'https://facebook.com/dropbox',
    // eslint-disable-next-line no-restricted-syntax
    linkedin: 'https://www.linkedin.com/company/dropbox',
  },

  getDefaultProps() {
    return {
      siteCode: siteCodes.sign,
    };
  },

  render() {
    const { responsive } = this.props;
    const cmsSubDomain = 'www';
    const site = HfReactHelper.HfSites.getSite(this.props.siteCode);
    const isHf = HfReactHelper.isHelloFax();
    const pricingUrl = HfReactHelper.urlHelper('info/pricing', site);
    const hfHomeUrl = HfReactHelper.urlHelper(
      'home/bridge/to/F',
      HfReactHelper.HfSites.SITE_CODE_HS,
    );
    const hsHomeUrl = HfReactHelper.urlHelper(
      'home/bridge/to/S',
      HfReactHelper.HfSites.SITE_CODE_HF,
    );
    const helpUrl = HfReactHelper.urlHelper('home/help', site);
    const bridgeUrl = isHf ? hsHomeUrl : hfHomeUrl;

    const socialImageUrls = {
      twitter: twitterImageSrc,
      fb: facebookImageSrc,
      linkedin: linkedinImageSrc,
    };

    const social = this.SOCIAL_NAMES.map((name) => (
      <div
        key={name}
        className={classNames('m-app-footer--social--icon', styles.socialIcon)}
      >
        <a
          href={this.SOCIAL_URLS[name]}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="m-app-footer--social--icon--img"
            src={socialImageUrls[name]}
          />
        </a>
      </div>
    ));

    const items = [
      isHf ? undefined : (
        <MenuLink
          key={0}
          href={HfReactHelper.urlHelper('api', site, cmsSubDomain)}
        >
          <FormattedMessage
            id=""
            description="webapp, homepage footer product link dd api"
            defaultMessage="API"
          />
        </MenuLink>
      ),
      isHf ? undefined : (
        <MenuLink
          key={1}
          href={HfReactHelper.urlHelper('gmail', site, cmsSubDomain)}
        >
          <FormattedMessage
            id=""
            description="webapp, homepage footer product link dd gmail"
            defaultMessage="Gmail"
          />
        </MenuLink>
      ),
      <MenuLink
        key={2}
        href={HfReactHelper.urlHelper('googledocs', site, cmsSubDomain)}
      >
        <FormattedMessage
          id=""
          description="webapp, homepage footer product link dd google docs"
          defaultMessage="Google Docs"
        />
      </MenuLink>,
      <MenuLink
        key={3}
        href={HfReactHelper.urlHelper('googledrive', site, cmsSubDomain)}
      >
        <FormattedMessage
          id=""
          description="webapp, homepage footer product link dd google drive"
          defaultMessage="Google Drive"
        />
      </MenuLink>,
      <MenuLink
        key={5}
        href={bridgeUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {getBrandName(this.props.siteCode)}
      </MenuLink>,
    ];

    const finePrintItems = [
      <MenuLink
        key={0}
        href={HfReactHelper.urlHelper('info/security', site, cmsSubDomain)}
      >
        <FormattedMessage
          id=""
          description="webapp, homepage footer fine print link dd security"
          defaultMessage="Security"
        />
      </MenuLink>,
      isHf ? undefined : (
        <MenuLink
          key={1}
          href={HfReactHelper.urlHelper('info/legal', site, cmsSubDomain)}
        >
          <FormattedMessage
            id=""
            description="webapp, homepage footer fine print link dd legal"
            defaultMessage="Legal"
          />
        </MenuLink>
      ),
      <MenuLink key={2} href={this.props.privacyURL}>
        <FormattedMessage
          id=""
          description="webapp, homepage footer fine print link dd privacy"
          defaultMessage="Privacy"
        />
      </MenuLink>,
      <MenuLink key={3} href={this.props.termsURL}>
        <FormattedMessage
          id=""
          description="webapp, homepage footer fine print link dd terms"
          defaultMessage="Terms"
        />
      </MenuLink>,
    ];

    return (
      <div
        className={classNames(
          styles.footerContainer,
          'm-app-footer--container',
          {
            [styles.responsive]: responsive,
          },
        )}
      >
        <div className={classNames(styles.footer)}>
          <div className={classNames(styles.footerLogo, 'm-app-footer--logo')}>
            <Logo siteCode={this.props.siteCode} variant="glyph" />
          </div>
          <div className={classNames(styles.footerLinks, '_footer__links')}>
            <div
              className={classNames(
                styles.linkContainer,
                'm-app-footer--links--link',
              )}
            >
              <a target="_blank" href={pricingUrl} rel="noreferrer">
                <FormattedMessage
                  id=""
                  description="webapp, homepage footer pricing link"
                  defaultMessage="Pricing"
                />
              </a>
            </div>
            <div
              className={classNames(
                styles.linkContainer,
                'm-app-footer--links--link product-link',
              )}
            >
              <LegacyFooterHoverMenu
                trigger={
                  <a>
                    <FormattedMessage
                      id=""
                      description="webapp, homepage footer products link"
                      defaultMessage="Products"
                    />
                  </a>
                }
              >
                {items}
              </LegacyFooterHoverMenu>
            </div>
            <div
              className={classNames(
                styles.linkContainer,
                'm-app-footer--links--link fine-print-link',
              )}
            >
              <LegacyFooterHoverMenu
                trigger={
                  <a>
                    <FormattedMessage
                      id=""
                      description="webapp, homepage footer fine print link"
                      defaultMessage="Fine print"
                    />
                  </a>
                }
              >
                {finePrintItems}
              </LegacyFooterHoverMenu>
            </div>
            <div
              className={classNames(
                styles.linkContainer,
                'm-app-footer--links--link',
              )}
            >
              <a target="_blank" href={helpUrl} rel="noreferrer">
                <FormattedMessage
                  id=""
                  description="webapp, homepage footer help link"
                  defaultMessage="Help"
                />
              </a>
            </div>
          </div>
        </div>
        <div
          className={classNames(
            styles.footerSocial,
            '_footer__social m-app-footer--social',
          )}
        >
          {social}
        </div>
      </div>
    );
  },
});

export default AppFooter;
